import { AuthGuard } from '@/components/guard'
import SelectOrganizationPlan from '@/features/organizations/select-organization-plan'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(setup)/select-organization-plan')({
  component:  () => (
    <AuthGuard>
      <SelectOrganizationPlan />
    </AuthGuard>
  ),
})
